import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import type {
  MfaBackupCodeRequest,
  MfaBackupCodeResponse,
  MfaEnableRequest,
  MfaLoginRequest,
  MfaLoginWithOTPRequest,
  MfaSetupRequest,
  MfaUpdateBackupEmailRequest,
  MfaVerifyBackupEmailRequest,
} from '@sb/shared/auth/data-access';
import { MfaService } from '@sb/shared/auth/data-access';

import type { AppState } from '../reducers/interfaces';
import { MfaService as LegacyMfaService, mfaState } from '../reducers/mfa/mfa.service';

/**
 * Bridge that connects the abstract `MfaService` (from the library) to the
 * existing NgRx-based `MfaService` in the main app.
 */
@Injectable()
export class MfaServiceBridge implements MfaService {
  #store = inject<Store<AppState>>(Store);
  #legacy = inject(LegacyMfaService);

  mfaState = this.#store.selectSignal(mfaState);

  login(data: MfaLoginRequest) {
    return this.#legacy.login(data);
  }

  loginWithOTP(data: MfaLoginWithOTPRequest) {
    return this.#legacy.loginWithOTP(data);
  }

  setup(payload: MfaSetupRequest) {
    return this.#legacy.setup(payload);
  }

  enable(payload: MfaEnableRequest) {
    return this.#legacy.enable(payload);
  }

  verifyBackupCode(data: MfaBackupCodeResponse) {
    return this.#legacy.verifyBackupCode(data);
  }

  getBackupCode(data: MfaBackupCodeRequest) {
    return this.#legacy.getBackupCode(data);
  }

  sendEmailWithOTPCode() {
    return this.#legacy.sendEmailWithOTPCode();
  }

  updateBackupEmail(payload: MfaUpdateBackupEmailRequest) {
    return this.#legacy.updateBackupEmail(payload);
  }

  verifyBackupEmail(payload: MfaVerifyBackupEmailRequest) {
    return this.#legacy.verifyBackupEmail(payload);
  }

  updatePromoteState() {
    return this.#legacy.updatePromoteState();
  }
}
